import toast from 'react-hot-toast'
import { Button } from 'components/common'
import { DownloadIcon } from 'components/icons'
import { downloadOrdersLogs } from 'utils/api/logsApi'
import { useQuery } from 'hooks'
import { filterEmptyValues } from 'utils/helpers'

const OrdersLogExportButton = () => {
  const { getQuery } = useQuery()

  const downloadCsv = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      // Orders log keeps each filter as its own URL query param
      const logFilter = filterEmptyValues({
        type: getQuery('type'),
        status: getQuery('status'),
        orderNo: getQuery('orderNo'),
        startDate: getQuery('startDate'),
        endDate: getQuery('endDate'),
      })

      await downloadOrdersLogs(
        Object.keys(logFilter).length > 0 ? logFilter : undefined,
      )
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <div className="mb-5">
      <Button
        buttonText="Export"
        className="w-40 px-0"
        icon={<DownloadIcon />}
        onClick={downloadCsv}
      />
    </div>
  )
}

export default OrdersLogExportButton
